import { FIELD_TYPES } from "constants/template-field-type";
import { IPO_CAMPAIGN_ID, GARTNER_CAMPAIGN_ID } from "constants/sales/campaigns";
import { buttonColors } from "segments/button-service";
import { BRAND_BLACK_BACKGROUND_COLOR } from "styles/color-consts";
const CTA_TEXT_OPTIONS = [
    {
        value: "contactSales.hubspotForm.form.contactSalesButton",
        text: "Contact Sales"
    },
    {
        value: "contactSales.hubspotForm.form.contactUsButton",
        text: "Contact us"
    },
    {
        value: "header.requestADemo",
        text: "Request a demo"
    },
    {
        value: "pricingPage.get_quote",
        text: "Get a quote"
    },
    {
        value: "forms.defaultSubmitButton",
        text: "Submit"
    }
];
export default {
    ctaProps: {
        type: FIELD_TYPES.NESTED,
        label: "CTA props",
        fields: {
            overrideText: {
                type: FIELD_TYPES.COMBO,
                label: "Button CTA text",
                options: CTA_TEXT_OPTIONS
            },
            color: {
                type: FIELD_TYPES.COLOR_PICKER,
                label: "CTA color",
                possibleColors: [
                    ...buttonColors,
                    BRAND_BLACK_BACKGROUND_COLOR
                ]
            },
            invert: {
                type: FIELD_TYPES.BOOLEAN,
                label: "Outlined CTA"
            }
        }
    },
    overrideCampaignId: {
        type: FIELD_TYPES.COMBO,
        options: [
            {
                value: IPO_CAMPAIGN_ID,
                text: "IPO promotion"
            },
            {
                value: GARTNER_CAMPAIGN_ID,
                text: "Gartner campaign"
            }
        ],
        label: "Override campaign"
    },
    lastNameFirst: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Place Last Name before First Name"
    },
    bamTimeout: {
        type: FIELD_TYPES.TEXT,
        label: "Book a meeting call timeout (in milliseconds)"
    },
    enableLoader: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Enable loader"
    }
};
